<template>
  <svg xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 165 200"
    aria-labelledby="Marker"
    role="presentation"
  >
    <g>
      <g>
        <g>
          <g>
            <path :fill="iconColor" d="M82.4,197.3c-3.8,0-7.4-1.5-10.2-4.1c-20.7-20.2-69-71.4-69-110.7c0-43.5,35.4-79,79-79
              c43.5,0,79,35.4,79,79c0,42.2-48.1,91.6-68.8,110.9C89.6,195.9,86.1,197.3,82.4,197.3C82.4,197.3,82.4,197.3,82.4,197.3z"/>
            <path fill="#FFFFFF" d="M82.1,5.1c42.7,0,77.3,34.6,77.3,77.3c0,41.6-47.9,90.7-68.3,109.7c-2.5,2.3-5.7,3.5-8.8,3.5
              c-3.3,0-6.5-1.2-9.1-3.7C53,172.2,4.8,121.2,4.8,82.5C4.8,39.8,39.4,5.1,82.1,5.1 M82.1,1.9C37.7,1.9,1.6,38,1.6,82.5
              c0,39.9,48.6,91.5,69.5,111.8c3.1,3,7.1,4.6,11.3,4.6c4.1,0,8-1.5,11.1-4.4c20.8-19.4,69.3-69.2,69.3-112.1
              C162.7,38,126.6,1.9,82.1,1.9L82.1,1.9z"/>
          </g>
        </g>
      </g>
      <g>
        <path fill="#FFFFFF" d="M81.7,107.6c-17.7,0-32-14.3-32-32s14.3-32,32-32c17.7,0,32,14.3,32,32S99.4,107.6,81.7,107.6z"/>
      </g>
      <g>
        <g>
          <path :fill="iconColor" d="M82,147.1c-27.1,0-51.4-12.1-67.8-31.1c15,30.7,44.5,61.6,59.3,76c5,4.8,12.8,4.9,17.9,0.2
            c15.6-14.6,47.3-46.7,61.3-79.6C136.2,133.6,110.7,147.1,82,147.1z"/>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: '#909090'
    }
  }
}
</script>